"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9284],{

/***/ 39284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ BrandSection_BrandSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(10990);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./src/constant/index.tsx + 38 modules
var constant = __webpack_require__(17089);
;// CONCATENATED MODULE: ./src/views/Home/BrandSection/BrandSection.tsx






function BrandSection() {
    // Gsap Animations
    (0,react.useEffect)(function() {
        var BrandSectionTimeline = gsap/* default.timeline */.ZP.timeline({
            scrollTrigger: {
                trigger: "._brandTrigger",
                start: "top 75%"
            },
            defaults: {
                duration: 1.4
            }
        });
        if (window.matchMedia("(max-width: 700px)").matches) {} else {
            var BrandSectionScrubTimeline = gsap/* default.timeline */.ZP.timeline({
                scrollTrigger: {
                    trigger: "._brandTrigger",
                    start: "`top 75%",
                    scrub: 0.5
                }
            });
            BrandSectionScrubTimeline.to("._brandRightSide", {
                y: 50,
                duration: 0.3
            }).to("._brandLeftSide", {
                y: -100
            }, "start");
        }
        BrandSectionTimeline.to("._brandRightSide", {
            opacity: 1
        }, "start").to("._brandTexts, ._brandImages", {
            y: 0,
            opacity: 1
        }, "start");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "mb-0 lg:mb-[8.57143rem] before:content-[''] before:table after:content-[''] after:table after:clear-both _brandTrigger flex lg:block flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "__otherWordBg p-[3.07143rem] lg:p-[4.28571rem_4.28571rem_7.28571rem_6.92857rem] desktop:p-[5rem_4.28571rem_13.2rem_6.92857rem] lg:mb-[11.42857rem] lg:w-[58.33333%] float-left relative z-[1] _brandLeftSide hidden lg:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "_brandTexts -translate-y-8 opacity-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pl-[2.85714rem] uppercase font-primary font-semibold text-[0.92857rem] leading-[1.42857em] tracking-[0.13286rem] my-[1.67em] text-white after:bg-white after:left-0 after:absolute after:top-[50%] after:translate-y-[-50%] after:h-[2px] after:w-[1.5rem] after:content-[''] relative",
                                children: "Brands"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "relative text-[1.57143rem] md:text-[1.85714rem] leading-[1.22727em] md:leading-[1.23077em] tracking-normal font-bold my-[0.83em] text-white",
                                children: "Happy Clients."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "relative text-white font-light text-[1.57143rem] leading-[1.22727em] tracking-normal my-[1em] lg:pr-[1.42857rem] lg:mb-[3rem]",
                                children: "Creating digital experiences for small black-owned businesses to leading Fortune 500 companies & brands. 5 years and counting."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "grid grid-cols-2 md:grid-cols-4 px-4 lg:px-0 gap-x-[40px] lg:gap-x-[30px] xl:gap-x-[70px] gap-y-[90px] mt-[50px] lg:mt-[90px] _brandImages translate-y-8 opacity-0",
                                children: constant/* brandImages.map */.ly.map(function(imageUrl, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "flex items-center justify-center",
                                        children: imageUrl.src
                                    }, "some_" + i);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "__otherWordBg p-[3.07143rem] lg:p-[4.28571rem_4.28571rem_7.28571rem_6.92857rem] desktop:p-[5rem_4.28571rem_13.2rem_6.92857rem] lg:mb-[11.42857rem] lg:w-[58.33333%] float-left relative z-[1] lg:hidden block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "_brandTexts -translate-y-8 opacity-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pl-[2.85714rem] uppercase font-primary font-semibold text-[0.92857rem] leading-[1.42857em] tracking-[0.13286rem] my-[1.67em] text-white after:bg-white after:left-0 after:absolute after:top-[50%] after:translate-y-[-50%] after:h-[2px] after:w-[1.5rem] after:content-[''] relative",
                                children: "Brands"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "relative text-[1.57143rem] md:text-[1.85714rem] leading-[1.22727em] md:leading-[1.23077em] tracking-normal font-bold my-[0.83em] text-white",
                                children: "Happy Clients."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "relative text-white font-light text-[1.57143rem] leading-[1.22727em] tracking-normal my-[1em] lg:pr-[1.42857rem] lg:mb-[3rem]",
                                children: "Creating digital experiences for small black-owned businesses to leading Fortune 500 companies & brands. 5 years and counting."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "grid grid-cols-2 md:grid-cols-4 px-4 lg:px-0 gap-x-[40px] lg:gap-x-[30px] xl:gap-x-[70px] gap-y-[90px] mt-[50px] lg:mt-[90px] _brandImages translate-y-8 opacity-0",
                                children: constant/* brandImages.map */.ly.map(function(imageUrl, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "flex items-center justify-center",
                                        children: imageUrl.src
                                    }, "jopjgsd_" + i);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:relative _brandRightSide hidden lg:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:absolute lg:right-0 lg:overflow-hidden lg:top-[0] z-0 lg:w-[58.33333%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            className: "lg:h-[53.57143rem] opacity-0 _brandImages m-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    layout: "fill",
                                    src: "/images/home/brand_section_right.webp",
                                    objectFit: "cover",
                                    alt: "brand image",
                                    priority: true,
                                    placeholder: "blur",
                                    blurDataURL: "/images/home/brand_section_right.webp"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:hidden block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:absolute lg:right-0 lg:overflow-hidden lg:top-[0] z-0 lg:w-[58.33333%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            className: "h-[50vh] relative lg:hidden block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    layout: "fill",
                                    src: "/images/home/brand_section_right.webp",
                                    objectFit: "cover",
                                    alt: "brand image",
                                    priority: true
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var BrandSection_BrandSection = (BrandSection);

;// CONCATENATED MODULE: ./src/views/Home/BrandSection/index.ts




/***/ })

}]);